/**
 * 공개 웹 주소(스테이지별 .env 의 VITE_PUBLIC_BASE_URL — dev.hamlak.com·hamlak.com). 공유 링크처럼 앱 밖에서 여는 주소에 쓴다.
 * 로컬 개발처럼 비어 있으면 현재 출처.
 */
export const publicWebUrl = (path: string): string => {
  const base = (import.meta.env.VITE_PUBLIC_BASE_URL || window.location.origin).replace(/\/+$/, "");
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
};
